import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AchievementTypesComponent } from './achievement-types/achievement-types.component';
import {SharedModule} from '../../shared';
import {RouterModule} from '@angular/router';
import {ResourcesComponent} from './resources.component';
import {AnimationsComponent} from './animations/animations.component';
import {AnimationPreviewComponent} from './animations/animation-preview/animation-preview.component';
import {AnimationsUploadFormComponent} from './animations/animations-upload-form/animations-upload-form.component';

@NgModule({
  declarations: [
    AchievementTypesComponent,
    ResourcesComponent,
    AnimationsComponent,
    AnimationPreviewComponent,
    AnimationsUploadFormComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule.forChild([
      {
        path: '',
        component: ResourcesComponent
      }
    ])
  ]
})
export class ResourcesModule { }
